import RouteParser from '@/tools/route-parser'
import { translateObjectKeys, compact } from '@/tools/object'
import { DEFAULT_SELECTED_OPTIONS, AUTO_SELECTED_OPTIONS, FILTERS_OPTIONS } from '@/web/components/product-feed-filters/constants'
import normalizeOptionsFromURL from '@/web/components/product-feed-filters/normalize-options-from-url'
import store from '@/web/store'
import request from '@/web/store/modules/request'
import REQUEST from '@/web/store/registered/request'
import { encodeBase64, decodeBase64, isBase64 } from '@/tools/base64'

const STATIC_PARAMS = ['promotion_slug', 'discount_percentage_min', 'discount_percentage_max', 'published_before', 'seller_segmentation', 'plan_id']

const DYNAMIC_PARAMS =
  Object.keys(DEFAULT_SELECTED_OPTIONS)
    .concat(['query', 'department', 'current_page_cursor', 'previous_pages_cursors', 'current_page'])
    .concat(STATIC_PARAMS)

function getParamsFromUrl() {
  const params = request.getters[REQUEST.GETTERS.GET_PARAMS](request.state)

  if (params.current_page_cursor && isBase64(params.current_page_cursor)) {
    params.current_page_cursor = decodeBase64(params.current_page_cursor)
  }

  if (params.previous_pages_cursors && isBase64(params.previous_pages_cursors)) {
    params.previous_pages_cursors = decodeBase64(params.previous_pages_cursors).split(',')
  }

  return params
}

export function getNormalizedParamsFromUrl() {
  return normalizeOptionsFromURL(getParamsFromUrl())
}

export function removeFiltersAppliedNotAllowed(filtersApplied , filterTypes) {
  return filterTypes.reduce((filtersAppliedAllowed, filterType) => {
    FILTERS_OPTIONS[filterType].forEach(filter => {
      if (typeof filtersApplied[filter] !== 'undefined') {
        filtersAppliedAllowed[filter] = filtersApplied[filter]
      }
    })

    return filtersAppliedAllowed
  }, {})
}

function getFixedParamsFromUrl() {
  const urlParams = getParamsFromUrl()

  return Object.keys(urlParams).reduce((fixedParams, paramName) => {
    if (DYNAMIC_PARAMS.indexOf(paramName) === -1) {
      fixedParams[paramName] = urlParams[paramName]
    }

    return fixedParams
  }, {})
}

export function setHistoryPushState(options) {
  const historyAction = `${options.method || 'push'}State`
  const route = request.getters[REQUEST.GETTERS.GET_ROUTE](request.state)
  const routeParser = new RouteParser(route.spec, route.parserOptions)
  const abbrParamsMap = route.abbrParamsMap
  const appliedOptions = Object.assign({}, options.appliedOptions)
  const staticOptions = Object.assign({}, options.staticOptions)

  const { term, department, currentPageCursor, previousPagesCursors, searchId } = options

  let paramsForUrl = translateObjectKeys(
    Object.assign(
      {},
      getFixedParamsFromUrl(),
      { query: term },
      { department },
      { search_id: searchId },
      { ...appliedOptions },
      { ...staticOptions },
      currentPageCursor ? { current_page_cursor: encodeBase64(currentPageCursor, { urlSafe: true }) } : {},
      previousPagesCursors && previousPagesCursors.length ? { previous_pages_cursors: encodeBase64(previousPagesCursors.join(','), { urlSafe: true }) } : {}
    ),
    abbrParamsMap
  )

  paramsForUrl = compact(paramsForUrl, { removeValues: [''] })

  history[historyAction](null, null, routeParser.toString(paramsForUrl))

  store.dispatch(REQUEST.ACTIONS.PARSE_PARAMS)
}

export function getFiltersApplied(paramsFromUrl) {
  return Object.keys(DEFAULT_SELECTED_OPTIONS).reduce((filtersApplied, filter) => {
    if (typeof paramsFromUrl[filter] !== 'undefined') {
      filtersApplied[filter] = paramsFromUrl[filter]
    } else if (AUTO_SELECTED_OPTIONS[filter]) {
      const autoValue = AUTO_SELECTED_OPTIONS[filter]()

      if (autoValue) {
        filtersApplied[filter] = autoValue
      }
    }

    return filtersApplied
  }, {})
}

export function getStaticOptions(paramsFromUrl) {
  return STATIC_PARAMS.reduce((staticOptions, option) => {
    if (paramsFromUrl[option])
      staticOptions[option] = paramsFromUrl[option]

    return { ...staticOptions }
  }, {})
}
